import { Box } from '@mui/material';
import AppBar from 'components/app-bar/app-bar.component';
import { ScrollContainerProvider } from 'components/inc-page/inc-page-tabs/inc-page-tabs.context';
import { useScrollContainer } from 'components/inc-page/inc-page-tabs/inc-page-tabs.hooks';
import Sidebar from 'components/sidebar/sidebar.component';
import { usePrunedRoutes } from 'hooks/routes.hooks';
import mainRoutes from 'pages/main-routes';
import { Outlet } from 'react-router-dom';
import { useMainLayoutComponent } from './main-layout.hooks';

const MainLayout = () => {
  const { sidebarOpen, onCloseSidebar } = useMainLayoutComponent();
  const scrollRef = useScrollContainer();
  const routeConfig = usePrunedRoutes([mainRoutes[1]]);

  return (
    <Box display="flex" width="100%" height="100%">
      <Sidebar
        routeConfig={routeConfig[0]}
        open={sidebarOpen}
        onClose={onCloseSidebar}
      />
      <Box
        flexGrow={1}
        height="100%"
        display="flex"
        flexDirection="column"
        sx={{ overflowX: 'auto' }}
      >
        <AppBar />
        <Box
          component="main"
          display="flex"
          flexGrow={1}
          flexDirection="column"
          sx={{ overflowY: 'auto', scrollBehavior: 'smooth' }}
          id="main"
          ref={scrollRef}
        >
          <ScrollContainerProvider value={scrollRef}>
            <Outlet />
          </ScrollContainerProvider>
        </Box>
      </Box>
    </Box>
  );
};

export default MainLayout;
